import React from 'react'
import ColumnMain from '../components/Columns/ColumnMain'
import Header from '../components/Shared/Header'
import Footer from '../components/Shared/Footer'

function Columns() {
  return (
    <div>
    <Header />
    <ColumnMain />
    <Footer />
    </div>
  )
}

export default Columns
